module.exports = require("./fr-CG.js");